<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改驾驶员信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="vehicleDriverInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">驾驶员名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleDriverInfo.name" placeholder="请输入驾驶员名称">
        </Input>
      </FormItem>
      <FormItem prop="idCardNum">
        <label style="display: inline-block; width: 60px;">身份证号码</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleDriverInfo.idCardNum" placeholder="请输入身份证号码">
        </Input>
      </FormItem>
      <FormItem prop="driverCardNum">
        <label style="display: inline-block; width: 60px;">司机卡号</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleDriverInfo.driverCardNum" placeholder="请输入司机卡号">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <label style="display: inline-block; width: 60px;">联系电话</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleDriverInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <label style="display: inline-block; width: 60px;">联系地址</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleDriverInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="vehicleDriverInfo.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'VehicleDriverInfoDetailModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '驾驶员名称不能为空', trigger: 'blur' }
          ]
        }
      },
      idCardNumRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '身份证号码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        modify: false,
        vehicleDriverInfo: {
          id:null,
          idCardNum:null,
          driverCardNum:null,
          name:null,
          phoneNum:null,
          address:null,
          remark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'VehicleDriverInfoServ_GetDetail',
        'VehicleDriverInfoServ_ModifyObj'
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改驾驶员信息',
            content: '<p>确认修改驾驶员信息</p>',
            onOk: () => {
              store.dispatch('VehicleDriverInfoServ_ModifyObj', {
                params: this.vehicleDriverInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let vehicleDriverInfoId = this._initValue
              store.dispatch('VehicleDriverInfoServ_GetDetail', {
                params: {id: vehicleDriverInfoId}
              }).then(() => {
                this.vehicleDriverInfo = store.getters.get_VehicleDriverInfo_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if (val) {
          this.modify = false
          this.id = null
          this.vehicleDriverInfo.name = null
          this.vehicleDriverInfo.phoneNum = null
          this.vehicleDriverInfo.address = null
          this.vehicleDriverInfo.remark = null
          this.vehicleDriverInfo.idCardNum = null
          this.vehicleDriverInfo.driverCardNum = null
          let vehicleDriverInfoId = this._initValue
          if (vehicleDriverInfoId) {
            store.dispatch('VehicleDriverInfoServ_GetDetail', {
              params: {id: vehicleDriverInfoId}
            }).then(() => {
              this.vehicleDriverInfo = store.getters.get_VehicleDriverInfo_GetDetailResult;
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules() {
        return {
          name: this.nameRules,
          idCardNum: this.idCardNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
